import { DialogActions, DialogContent } from '@mui/material';
import { useAppTFunction } from '@retail/app/i18n';
import { SuspenseWithSentryErrorBoundary } from '@retail/components';
import { MgSupplierItemSearchContainer } from '@retail/products/containers';
import { MgSupplierItemSearchResult } from '@retail/products/types';
import { ContainedButton, TextButton } from '@shared/components';

interface Props {
  assortmentId: number;
  selectedSearchItems: MgSupplierItemSearchResult[];
  setSelectedSearchItems: (items: MgSupplierItemSearchResult[]) => void;
  onContinue: () => void;
  onClose: () => void;
}

export function AddLocalPricesFromItemSearch({
  assortmentId,
  selectedSearchItems,
  setSelectedSearchItems,
  onContinue,
  onClose,
}: Props) {
  const t = useAppTFunction();
  return (
    <>
      <DialogContent
        className="padding-0"
        sx={{ display: 'flex', flexGrow: 1, flexDirection: 'column' }}
      >
        <SuspenseWithSentryErrorBoundary>
          <MgSupplierItemSearchContainer
            assortmentId={assortmentId}
            checkedItems={selectedSearchItems}
            setCheckedItems={setSelectedSearchItems}
          />
        </SuspenseWithSentryErrorBoundary>
      </DialogContent>
      <DialogActions>
        <TextButton onClick={onClose} size="small">
          {t('common.cancel')}
        </TextButton>
        <ContainedButton
          size="small"
          color="secondary"
          disabled={selectedSearchItems.length === 0}
          onClick={onContinue}
        >
          {t('myAssortment.actions.continueWithItems')}
        </ContainedButton>
      </DialogActions>
    </>
  );
}
